import { AppBar, IconButton, Toolbar } from "@mui/material";
import { useState } from "react";
import { useMatch } from "react-router";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import UserAvatar from "@entrilia/shared/components/UserAvatar";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import UserContext from "../../context/UserContext";
import { pageRoutes, routePermissions } from "../../routes";
import PageLink from "./PageLink";
import UserMenu from "./UserMenu";

const Header = () => {
  const { userInfo, permissions } = useDefinedContext(UserContext);

  const routeMatch = useMatch("/:pageName/*");

  const [userIconEl, setUserIconEl] = useState<HTMLElement | null>(null);

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const pageName = routeMatch?.params["pageName"];

  const showMaintenance = routePermissions[pageRoutes.systemMaintenance].some((p) => permissions.includes(p));
  const showClientManagement = routePermissions[pageRoutes.clientManagement].some((p) => permissions.includes(p));
  const showEntriliaUsers = routePermissions[pageRoutes.entriliaUsersManagement].some((p) => permissions.includes(p));
  const showAgents = routePermissions[pageRoutes.agents].some((p) => permissions.includes(p));
  const showObserver = routePermissions[pageRoutes.observer].some((p) => permissions.includes(p));

  return (
    <AppBar position="sticky">
      <Toolbar>
        {showMaintenance && (
          <PageLink
            title="Maintenance"
            link={`/${pageRoutes.systemMaintenance}`}
            highlighted={pageName === pageRoutes.systemMaintenance}
          />
        )}
        {showClientManagement && (
          <PageLink
            title="Client Management"
            link={`/${pageRoutes.clientManagement}`}
            highlighted={pageName === pageRoutes.clientManagement}
          />
        )}
        {showEntriliaUsers && (
          <PageLink
            title="Entrilia Users Management"
            link={`/${pageRoutes.entriliaUsersManagement}`}
            highlighted={pageName === pageRoutes.entriliaUsersManagement}
          />
        )}
        {showAgents && (
          <PageLink title="Agents" link={`/${pageRoutes.agents}`} highlighted={pageName === pageRoutes.agents} />
        )}
        {showObserver && (
          <PageLink title="Observer" link={`/${pageRoutes.observer}`} highlighted={pageName === pageRoutes.observer} />
        )}

        <HorizontalFill />

        <IconButton
          sx={{ ml: 1 }}
          onClick={() => setIsUserMenuOpen((prev) => !prev)}
          ref={(el) => {
            setUserIconEl(el);
          }}
        >
          <UserAvatar size="large" userName={userInfo.name} />
        </IconButton>
        <UserMenu open={isUserMenuOpen} anchorEl={userIconEl} onClose={() => setIsUserMenuOpen(false)} />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
